import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import { Card, Dialog, DialogTitle, IconButton, InputLabel, MenuItem } from '@material-ui/core';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// context
import CloseIcon from '@material-ui/icons/Close';
import { Autocomplete } from '@mui/material';
import Store from '../../store';
import Actions from '../../store/actions';

// api
import {
  fetchLetterPmrCurationDetails,
  submitLetterPmrCurationDetails,
  submitLetterPmrRequirementCurationDetails,
  deleteLetterPmrRequirementCurationDetails
} from '../../api/Cder';

// helpers
import { handleChange } from '../../helpers/changeHandler';

// styles
import Styles from './styles/LetterPmrReviewPage';
import { PmrcSectionOptions } from './constants';

// eslint-disable-next-line react/prop-types
const LetterPmrDialog = ({ docsId, closeEdit }) => {
  const classes = Styles();
  const history = useHistory();
  const { dispatch } = useContext(Store);
  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const [initialData, setInitialData] = useState({});
  const [cmtNumber, setCmtNumber] = useState();
  const [cmtDesc, setCmtDesc] = useState();
  const [qcStatus, setQcStatus] = useState('qced');
  const [sectionOptions, setSectionOptions] = useState();
  const [section, setSection] = useState('ACCELERATED APPROVAL REQUIREMENTS');
  const [status, setStatus] = useState('qced');
  const [formSubmit, setFormSubmit] = useState(false);
  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const [pdfLink, setPdfLink] = useState();

  const handleClose = () => {
    closeEdit();
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const user = await Auth.currentUserInfo();
        setEmail(user.attributes.email);
        setName(user.attributes['custom:user']);
        // eslint-disable-next-line react/prop-types,react/destructuring-assignment
        const res = await fetchLetterPmrCurationDetails(docsId);
        if (isEmpty(res.data?.body?.results)) {
          await dispatch({
            type: Actions.SET_ALERT,
            value: { status: true, message: 'Enter valid information' }
          });
          handleClose();
        }
        setInitialData(res.data.body.results);
        setQcStatus(res.data.body.results?.qc_status || 'qced');
        setPdfLink(res.data.body.results.document_link);
        setSectionOptions(PmrcSectionOptions);
      } catch (error) {
        await dispatch({
          type: Actions.SET_ALERT,
          value: { status: true, message: 'Enter valid information' }
        });
        handleClose();
      }
      setFormSubmit(false);
    }

    fetchData();
    // eslint-disable-next-line react/destructuring-assignment,react/prop-types
  }, [formSubmit, dispatch, history]);

  const handleEdit = prevData => {
    setEditMode(true);
    setCmtNumber(prevData.cmt_number);
    setCmtDesc(prevData.cmt_desc);
    setStatus(prevData.qc_status);
    setSection(prevData.section);
  };
  const handleDeleteButton = prevData => {
    setDeleteMode(true);
    setCmtNumber(prevData.cmt_number);
    setCmtDesc(prevData.cmt_desc);
    setStatus(prevData.qc_status);
    setSection(prevData.section);
  };

  const openAddNew = () => {
    setCmtDesc('');
    setCmtNumber('');
    setStatus('qced');
    setSection();
    setEditMode(true);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      const payload = {
        section,
        cmt_number: cmtNumber,
        cmt_desc: cmtDesc,
        qc_status: status,
        curator_email: email,
        curator_name: name
      };
      await submitLetterPmrRequirementCurationDetails(docsId, payload);
      setEditMode(false);
      setFormSubmit(true);
    } catch (error) {
      await dispatch({
        type: Actions.SET_ALERT,
        value: { status: true, message: error }
      });
    }
  };

  const handleDelete = async () => {
    try {
      const payload = {
        section,
        cmt_number: cmtNumber,
        cmt_desc: cmtDesc,
        qc_status: status,
        curator_email: email,
        curator_name: name
      };
      await deleteLetterPmrRequirementCurationDetails(docsId, payload);
      setDeleteMode(false);
      closeEdit();
    } catch (error) {
      await dispatch({
        type: Actions.SET_ALERT,
        value: { status: true, message: error }
      });
    }
  };

  const handleQcStatusUpdate = async e => {
    e.preventDefault();
    try {
      const payload = {
        qc_status: qcStatus,
        curator_email: email,
        curator_name: name
      };
      await submitLetterPmrCurationDetails(docsId, payload);
      closeEdit();
    } catch (error) {
      await dispatch({
        type: Actions.SET_ALERT,
        value: { status: true, message: error }
      });
    }
  };
  return (
    <Container className={classes.root}>
      <div>
        <DialogTitle className={{ m: 0, p: 2 }}>
          <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography component='h2' variant='h5' className={classes.Heading}>
              {initialData?.title}
            </Typography>
            {!editMode ? (
              <Button
                onClick={openAddNew}
                variant='contained'
                className={classes.submit}
                style={{ margin: '0 0 0 30px' }}>
                Add Record
              </Button>
            ) : null}
          </Box>
          <IconButton
            aria-label='close'
            onClick={() => {
              handleClose();
            }}
            style={{
              position: 'absolute',
              right: 5,
              top: 2,
              color: 'gray.light'
            }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Grid container spacing={2} display='flex'>
          <Grid item xs={12} lg={4}>
            <Box
              display='flex'
              flexDirection='column'
              justifyContent='space-around'
              style={{ padding: '10px 10px' }}>
              <Box className={classes.previousDataContainer}>
                <Typography component='h2' variant='h5' className={classes.Heading}>
                  Previous PMRC Curation
                </Typography>
                {initialData?.history_data &&
                Object.keys(initialData?.history_data)?.length !== 0 ? (
                  Object.entries(initialData?.history_data || {})
                    .filter(
                      ([key]) =>
                        key !== `${initialData?.submission_type}-${initialData?.submission_no}`
                    )
                    ?.map(([key, value]) => (
                      <Accordion key={key}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls='panel1-content'
                          id='panel1-header'>
                          {key}
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            height: '60vh',
                            overflowY: 'auto'
                          }}>
                          {value?.length ? (
                            value.map(item => (
                              <span>
                                {item?.requirements_data?.length ? (
                                  item.requirements_data.map(elem => (
                                    <Card
                                      style={{
                                        margin: '10px 0',
                                        border: '4px solid #d6d6d6',
                                        borderRadius: '4px'
                                      }}
                                      key={`${elem.application_docs_id}-${elem.cmt_number}`}>
                                      <Box
                                        className={classes.reviewBox}
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          position: 'relative'
                                        }}>
                                        <Box padding={1}>
                                          <Typography align='left' className={classes.label}>
                                            CMT Number
                                          </Typography>
                                          <Typography align='left' className={classes.details}>
                                            {elem.cmt_number}
                                          </Typography>
                                        </Box>
                                        <Box padding={1}>
                                          <Typography align='left' className={classes.label}>
                                            CMT Description
                                          </Typography>
                                          <Typography
                                            align='left'
                                            className={classes.previousdetails}>
                                            {elem.cmt_desc}
                                          </Typography>
                                        </Box>
                                        <Box padding={1}>
                                          <Typography align='left' className={classes.label}>
                                            Section
                                          </Typography>
                                          <Typography align='left' className={classes.details}>
                                            {elem.section}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Card>
                                  ))
                                ) : (
                                  <Card style={{ margin: '10px 0', padding: '10px' }}>
                                    <Box>
                                      <Typography>No CMT Data found</Typography>
                                    </Box>
                                  </Card>
                                )}
                              </span>
                            ))
                          ) : (
                            <Card style={{ margin: '10px 0', padding: '10px' }}>
                              <Box>
                                <Typography>No CMT Data found</Typography>
                              </Box>
                            </Card>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    ))
                ) : (
                  <Card style={{ margin: '10px 0', padding: '10px' }}>
                    <Box>
                      <Typography>No CMT Data found</Typography>
                    </Box>
                  </Card>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} lg={4}>
            {editMode ? (
              <form onSubmit={handleSubmit} style={{ paddingTop: '17px' }}>
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      variant='outlined'
                      fullWidth
                      id='cmt_number'
                      label='CMT Number'
                      value={cmtNumber}
                      required
                      onChange={e => setCmtNumber(handleChange(e))}
                      InputProps={{
                        style: { fontSize: '2vh', marginBottom: '15px' }
                      }}
                      InputLabelProps={{
                        style: { fontSize: '2vh', fontWeight: 'bold' }
                      }}
                    />
                  </Grid>
                  <TextField
                    multiline
                    minRows={3}
                    maxRows={8}
                    variant='outlined'
                    fullWidth
                    id='cmt_desc'
                    label='CMT Description'
                    value={cmtDesc}
                    required
                    onChange={e => setCmtDesc(handleChange(e))}
                    InputProps={{
                      style: { fontSize: '2vh', marginBottom: '15px' }
                    }}
                    InputLabelProps={{
                      style: { fontSize: '2vh', fontWeight: 'bold' }
                    }}
                  />
                  <Autocomplete
                    id='section'
                    fullWidth
                    value={section}
                    options={sectionOptions}
                    onChange={(_, newValue) => setSection(newValue)}
                    style={{
                      '& .MuiInputBase-input': {
                        fontSize: '1.5vh',
                        minWidth: '250px'
                      },
                      '& .MuiFormLabel-root': {
                        fontSize: '1.5vh'
                      },
                      marginBottom: '15px'
                    }}
                    renderInput={params => (
                      <TextField
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...params}
                        label='Section'
                        variant='outlined'
                        required
                        InputLabelProps={{
                          style: { fontSize: '2vh', fontWeight: 'bold' }
                        }}
                      />
                    )}
                  />
                  <TextField
                    variant='outlined'
                    id='status'
                    label='QC Status'
                    fullWidth
                    select
                    value={status}
                    onChange={e => {
                      setStatus(e.target.value);
                    }}
                    InputProps={{
                      style: { fontSize: '1.5vh', minWidth: '250px' }
                    }}
                    InputLabelProps={{
                      style: { fontSize: '1.5vh' }
                    }}>
                    <MenuItem value='all documents'>All Documents</MenuItem>
                    <MenuItem value='qced'>Qced</MenuItem>
                    <MenuItem value='to_qc'>To QC</MenuItem>
                    <MenuItem value='escalate'>Escalate</MenuItem>
                    <MenuItem value='missing details'>Missing Details</MenuItem>
                  </TextField>

                  <Box
                    display='flex'
                    flexDirection='row'
                    justifyContent='space-around'
                    style={{ width: '100%' }}>
                    <Button
                      type='button'
                      variant='contained'
                      color='primary'
                      className={classes.submit}
                      onClick={() => {
                        setEditMode(false);
                      }}>
                      CLOSE
                    </Button>
                    <Button
                      type='submit'
                      variant='contained'
                      color='primary'
                      className={classes.submit}>
                      SUBMIT
                    </Button>
                  </Box>
                </Grid>
              </form>
            ) : (
              <Box
                display='flex'
                flexDirection='column'
                justifyContent='space-around'
                style={{ padding: '10px 10px' }}>
                <Box
                  style={{
                    overflowY: 'auto',
                    maxHeight: '60vh',
                    padding: '4px',
                    border: '4px solid #d6d6d6',
                    borderRadius: '4px'
                  }}>
                  {initialData?.requirements_data?.length ? (
                    initialData.requirements_data.map(elem => (
                      <Card
                        sx={{ display: 'flex' }}
                        style={{ margin: '10px 0' }}
                        key={`${elem.application_docs_id}-${elem.cmt_number}`}>
                        <Box
                          className={classes.reviewBox}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative'
                          }}>
                          <Button
                            size='small'
                            type='button'
                            variant='contained'
                            onClick={() => {
                              handleEdit(elem);
                            }}
                            color='primary'
                            className={classes.submit}
                            style={{
                              position: 'absolute',
                              right: 15,
                              top: 0,
                              color: 'gray.light'
                            }}>
                            Edit
                          </Button>
                          <Button
                            size='small'
                            type='button'
                            variant='contained'
                            onClick={() => {
                              handleDeleteButton(elem);
                            }}
                            color='primary'
                            className={classes.submit}
                            style={{
                              position: 'absolute',
                              right: '20%',
                              top: 0,
                              color: 'gray.light'
                            }}>
                            Delete
                          </Button>
                          <Box padding={1}>
                            <Typography align='left' className={classes.label}>
                              CMT Number
                            </Typography>
                            <Typography align='left' className={classes.details}>
                              {elem.cmt_number}
                            </Typography>
                          </Box>
                          <Box padding={1}>
                            <Typography align='left' className={classes.label}>
                              CMT Description
                            </Typography>
                            <Typography align='left' className={classes.details}>
                              {elem.cmt_desc}
                            </Typography>
                          </Box>
                          <Box padding={1}>
                            <Typography align='left' className={classes.label}>
                              Section
                            </Typography>
                            <Typography align='left' className={classes.details}>
                              {elem.section}
                            </Typography>
                          </Box>
                        </Box>
                      </Card>
                    ))
                  ) : (
                    <Card style={{ margin: '10px 0', padding: '10px' }}>
                      <Box>
                        <Typography>No CMT Data found</Typography>
                      </Box>
                    </Card>
                  )}
                </Box>
                <Box
                  style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
                  <Box style={{ width: '45%' }}>
                    <InputLabel id='qc-status-label'>QC Status</InputLabel>
                    <TextField
                      variant='outlined'
                      id='qc_status'
                      label='QC Status'
                      fullWidth
                      select
                      required
                      value={qcStatus}
                      onChange={e => {
                        setQcStatus(e.target.value);
                      }}
                      InputProps={{
                        style: { fontSize: '1.5vh', minWidth: '250px' }
                      }}
                      InputLabelProps={{
                        style: { fontSize: '1.5vh' }
                      }}>
                      <MenuItem value='qced'>Qced</MenuItem>
                      <MenuItem value='to_qc'>To QC</MenuItem>
                      <MenuItem value='escalate'>Escalate</MenuItem>
                      <MenuItem value='missing details'>Missing Details</MenuItem>
                    </TextField>
                  </Box>
                  <Button
                    type='submit'
                    variant='contained'
                    color='primary'
                    className={classes.submit}
                    onClick={handleQcStatusUpdate}>
                    SUBMIT
                  </Button>
                </Box>
              </Box>
            )}
          </Grid>
          <Grid item xs={12} lg={4}>
            {pdfLink ? (
              <Box display='flex' justifyContent='center'>
                <iframe
                  title='pdf'
                  src={pdfLink}
                  style={{
                    height: '100vh',
                    width: '50vw',
                    marginTop: '20px',
                    position: 'relative'
                  }}
                />
              </Box>
            ) : (
              <Box
                display='flex'
                justifyContent='center'
                alignItems='center'
                style={{ height: '100%', width: '100%' }}>
                <Typography style={{ fontSize: '20px', fontWeight: 'bold', color: '#33B187' }}>
                  Can&apos;t Open This PDF
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
        <Dialog
          disableEscapeKeyDown
          fullWidth
          maxWidth='xs'
          open={deleteMode}
          onClose={() => setDeleteMode(false)}>
          <DialogTitle id='alert-dialog-title'>
            <Box display='flex' justifyContent='space-between' alignItems='center'>
              <Typography style={{ color: '#3AB09E', fontSize: '20px', fontWeight: 'bold' }}>
                Confirm Delete
              </Typography>
              <IconButton aria-label='close' onClick={() => setDeleteMode(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Typography style={{ fontSize: '16px', color: 'GrayText', marginRight: '0' }}>
              Are you sure you have delete the CMT Number? {`${cmtNumber}`}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={() => handleDelete()} className={classes.submit}>
              Yes
            </Button>
            <Button
              variant='contained'
              onClick={() => setDeleteMode(false)}
              className={classes.submit}>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Container>
  );
};

export default LetterPmrDialog;
